// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
   width:300px;
   text-align: center;
   padding: 10px;
}
mat-form-field {
   width: 230px;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/corporate-setting/setting.component.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,kBAAkB;GAClB,aAAa;AAChB;AACA;GACG,YAAY;AACf","sourcesContent":["form {\n   width:300px;\n   text-align: center;\n   padding: 10px;\n}\nmat-form-field {\n   width: 230px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
